import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './globals.css'; // need to check if we can delete it (select customer dropdown cahngees without this file)
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([{
    path: '*',
    element: <App />,
    children: [{ path: '/*', element: <App /> }]
}]);

root.render(<RouterProvider router={router} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();